<div class="app-chrome">

  <youforce-header

    [cdnUrl]="youforceNavigationBarCdnUrl"

    [culture]="yfHeaderCulture()"

    [subHeaderItems]="menuItems()"

    [helpItems]="helpItems()"

    [activeItemId]="activeItemId()"

    (isRenderd)="onYFHeaderRendered($event)"

    (logoffClicked)="onLogoffClicked()"

    (loadingError)="onLoadingHeaderError($event)"

    (subMenuItemClicked)="onSubMenuItemClicked($event)"

    (helpMenuItemClicked)="onHelpMenuItemClicked($event)"

  ></youforce-header>


<div class="page-content">

  <router-outlet />

</div>



<app-confirm-dialog />

<yds-snackbar />

